import { ROLE_COLOR_PALETTE } from "../constants/accessCatalog.constants";

/**
 * Derive a stable color for a role from its `slug`. The backend contract does not carry a per-role color, so
 * we hash the slug into a fixed palette — deterministic, so the same role always renders the same dot color.
 */
export function roleColor(slug: string): string {
  let sum = 0;
  for (let i = 0; i < slug.length; i++) {
    sum += slug.charCodeAt(i);
  }
  return ROLE_COLOR_PALETTE[sum % ROLE_COLOR_PALETTE.length];
}
